import { TGetRenewVisaResidenceCardInformationGroupOutputDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-residence-card-information-group.dto";
import { Linkable } from "@/components/elements/Linkable";
import { Modal } from "@/components/elements/Modal";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { toNumber } from "@/utils/number";
import { getFullName } from "@/utils/string";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

type TWarningExcessResidenceCardFileModalProps = {
  residenceCardInformationGroupListData: TGetRenewVisaResidenceCardInformationGroupOutputDto[];
};

export const WarningExcessResidenceCardFileModal: FCC<TWarningExcessResidenceCardFileModalProps> = ({ residenceCardInformationGroupListData }) => {
  const queryClient = useQueryClient();

  const employeeExcessResidenceCardFileArr = useMemo(
    () =>
      residenceCardInformationGroupListData.length > 0
        ? residenceCardInformationGroupListData
            .map((item) => item.employee)
            .filter((item) => toNumber(item.residenceCardBackFilePath?.length) >= 10 || toNumber(item.residenceCardFrontFilePath?.length) >= 10)
        : [],
    [residenceCardInformationGroupListData],
  );

  return (
    <Modal
      isOpen={employeeExcessResidenceCardFileArr.length > 0}
      title="エラー"
      labelOk="外国人情報を再取得する"
      flexDirectionBtnAction="row-reverse"
      onOk={async () => await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_RESIDENCE_CARD_INFORMATION_GROUP] })}
      width={600}
      hiddenCloseBtn
      enableCloseIcon={false}
      justifyBtnAction="center"
    >
      <Stack sx={{ display: "block" }} mt={2} mb={3}>
        <Typography component="p" variant="subtitle1" mb={1}>
          以下の外国人は在留カードファイルの保存がすでに上限（最大10枚）に達しているため、外国人登録画面より不要な在留カードファイルを削除してから本入力とアップロードをお願い致します。
        </Typography>
        <Box component="ul">
          {employeeExcessResidenceCardFileArr.map((employee, index) => {
            const fullName = getFullName({ firstName: employee.firstName, lastName: employee.lastName, middleName: employee.middleName });
            return (
              <Typography component="li" variant="body14" key={index}>
                <Linkable
                  sx={{ display: "inline", textDecoration: "underline" }}
                  target="_blank"
                  href={`${getDynamicRoute(AppRoutes.employeeEdit, { id: employee.id })}#residence_card_front_file_input`}
                >
                  {`${fullName}さん`}
                </Linkable>
              </Typography>
            );
          })}
        </Box>
      </Stack>
    </Modal>
  );
};
